<div class="flex-bottom no-select">

    <div id="outer-container" class="auto-margin-x vh-center t25s mg-top-25 mg-bottom-25" style="border: 5px solid #4e8df5;">

        <!-- <div id="camera-container" class="bg-black-10 vh-center">

            <video #videoPlayer></video>
            <img [src]="successImageData">

        </div> -->
        <div id="camera-container" class="bg-black-10 vh-center">

            <video [ngStyle]="{'display': success ? 'none' : 'block'}" #videoPlayer></video>

            <img [ngStyle]="{'display': !success ? 'none' : 'block'}" style="height: 280px; background-size: cover;" [src]="successImageData">

        </div>
       
    

    </div>

    <div *ngIf="!success" style="height: 0px;" class="vh-center z-100">
        <img src="assets/faceOutline.png" alt="" style="margin-top: -310px; width: 160px; height: 230px;">
    </div>

    <div class="flex-right auto-margin-x v-center height-30 bd-black-10 pd-left-15 pd-right-15" style="border-radius: 5px;" (click)="toggleCamera()">

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-instagram" style="color: #4e8df5;">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
        </svg>

        <div class="mg-left-10 fs-8 fw-bold pointer" style="color: #4e8df5;">TOGGLE CAMERA</div>

    </div>
    <div class="allow-camera" *ngIf="cameraError">
<p><svg width="24" height="24" viewBox="0 0 24 25" fill="#FF0000" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.55984 5.99881L8.13984 4.58881L9.65984 2.92881H15.6598L17.4898 4.92881H20.6598C21.7598 4.92881 22.6598 5.82881 22.6598 6.92881V18.9288C22.6598 18.9788 22.6498 19.0288 22.6398 19.0888L20.6598 17.0988V6.92881H16.6098L14.7798 4.92881H10.5398L9.55984 5.99881ZM21.1498 23.2388L18.8298 20.9288H4.65984C3.55984 20.9288 2.65984 20.0288 2.65984 18.9288V6.92881C2.65984 6.33881 2.92984 5.80881 3.33984 5.43881L1.33984 3.43881L2.75984 2.02881L22.5598 21.8288L21.1498 23.2388ZM9.84984 11.9488C9.73984 12.2588 9.65984 12.5788 9.65984 12.9288C9.65984 14.5888 10.9998 15.9288 12.6598 15.9288C13.0098 15.9288 13.3298 15.8488 13.6398 15.7388L9.84984 11.9488ZM16.8298 18.9288L15.1498 17.2488C14.4198 17.6788 13.5698 17.9288 12.6598 17.9288C9.89984 17.9288 7.65984 15.6888 7.65984 12.9288C7.65984 12.0188 7.90984 11.1688 8.33984 10.4388L4.82984 6.92881H4.65984V18.9288H16.8298ZM15.4698 11.9088L17.5398 13.9788C17.6198 13.6388 17.6598 13.2888 17.6598 12.9288C17.6598 10.1688 15.4198 7.92881 12.6598 7.92881C12.2998 7.92881 11.9498 7.96881 11.5998 8.04881L13.6698 10.1188C14.5098 10.4188 15.1698 11.0788 15.4698 11.9088Z"
                fill="#FF0000" />
        </svg>
        <b>Camera Access Denied!</b>
    </p>
     <h6>Please allow us to access your camera from browser setting and then try again</h6>
        
    </div>

    <div  class="image-error" *ngIf="imagesizeerror">
        <h5>Please take the photo again.</h5>
    </div>







    <div class="mg-top-25 mg-left-25 mg-right-25 fs-11">
        <div class="" *ngIf="!button">
            <div (click)="processSnapshot()" [style.flex]="!success ? 1 : 0" class="flex-bottom br25 o-hide t5s height-45 pointer">
                <div class="flex-1 vh-center fw-bold bg-black-hov-10 txt-white-100 t5s" style="background-color: #126DE2;" [hidden]="cameraError">
                    {{ processing ? "Please wait ..." : "Take photo" }}

                </div>
            </div>
        </div>

        <div class="" *ngIf="button">


            <div (click)="retrySnapshot()" [style.flex]="success ? 1 : 0" class=" br25 o-hide t5s height-45 flex-bottom" [hidden]="hidebutton">
                <div class="justify-center v-center fw-bold bg-black-hov-10 t5s pointer mg-bottom-10" style="color: #126DE2; border: 2pt solid #126DE2; background-color: #ffff;border-radius: 50px; margin: auto;width: 50%;height: 45px;">

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mg-right-15">
                <polyline points="23 4 23 10 17 10"></polyline>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg> Retry

                </div>
            </div>

            <div (click)="submitImage()" [style.flex]="success ? 1 : 0" class="br25 o-hide t5s height-45 flex-bottom" [hidden]="hidebutton" style="margin-top: 15px;">
                <div class="vh-center fw-bold bg-black-hov-10 txt-white-100 t5s pointer mg-top-10 br25" style="background-color:#126DE2;height: 45px;margin: auto;width: 50%;">
                    Accept
                </div>
            </div>
        </div>
        <!-- <div (click)="retrySnapshot()" [style.flex]="success ? 1 : 0" class="flex-bottom br25 o-hide t5s height-45" [hidden]="hidebutton">
            <div class="flex-1 flex-right justify-center v-center fw-bold bg-black-hov-10 t5s pointer" style="color: #126DE2; border: 2pt solid #126DE2; background-color: #ffff;border-radius: 50px;">

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mg-right-15">
                    <polyline points="23 4 23 10 17 10"></polyline>
                    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                </svg> Retry

            </div>
        </div>

        <div (click)="submitImage()" [style.flex]="success ? 1 : 0" class="flex-bottom br25 o-hide t5s height-45" style="margin-left: 10px;" [hidden]="hidebutton">
            <div class="flex-1 vh-center fw-bold bg-black-hov-10 txt-white-100 t5s pointer" style="background-color:#126DE2">
                Accept
            </div>
        </div> -->



    </div>

    <ng-template [ngIf]="showloader">
        <div class="z-1000 absolute trbl-0 vh-center bg-white-50 blur-2 ">
            <div class="loadingio-spinner-rolling-sray298du2g ">
                <div class="ldio-ti8ltt9443b ">

                    <div></div>
                </div>

            </div>

        </div>
        <div class="z-1000 absolute fw-700 vh-center fs-16" style="position: relative;top: -100px;">Please Wait ....</div>
    </ng-template>


</div>

<!-- <div class="z-1000 absolute trbl-0 vh-center bg-white-50 blur-2 " *ngIf="showloader">
        <div class="loadingio-spinner-rolling-sray298du2g ">
            <div class="ldio-ti8ltt9443b ">
                <div></div>
            </div>
        </div>
    </div> -->
    <!-- Web Enage -->
<head>
    
    <script id='_webengage_script_tag' type='text/javascript'>
        var webengage;!function(w,e,b,n,g){function o(e,t){e[t[t.length-1]]=function(){r.__queue.push([t.join("."),
        arguments])}}var i,s,r=w[b],z=" ",l="init options track screen onReady".split(z),a="webPersonalization feedback survey notification notificationInbox".split(z),c="options render clear abort".split(z),p="Prepare Render Open Close Submit Complete View Click".split(z),u="identify login logout setAttribute".split(z);if(!r||!r.__v){for(w[b]=r={__queue:[],__v:"6.0",user:{}},i=0;i < l.length;i++)o(r,[l[i]]);for(i=0;i < a.length;i++){for(r[a[i]]={},s=0;s < c.length;s++)o(r[a[i]],[a[i],c[s]]);for(s=0;s < p.length;s++)o(r[a[i]],[a[i],"on"+p[s]])}for(i=0;i < u.length;i++)o(r.user,["user",u[i]]);setTimeout(function(){var f=e.createElement("script"),d=e.getElementById("_webengage_script_tag");f.type="text/javascript",f.async=!0,f.src=("https:"==e.location.protocol?"https://widgets.in.webengage.com":"http://widgets.in.webengage.com")+"/js/webengage-min-v-6.0.js",d.parentNode.insertBefore(f,d)})}}(window,document,"webengage");
        //  uat        
        //    webengage.init("in~826172d4");
        // Production
         webengage.init('in~58adcc15');
    </script>

        
</head>